import {animate, state, style, transition, trigger} from '@angular/animations';
import {NgTemplateOutlet} from '@angular/common';
import {Component, computed, input, output, TemplateRef} from '@angular/core';
import {IsActiveMatchOptions, RouterLink, RouterLinkActive} from '@angular/router';

import {TooltipDirective} from '../../../directives/tooltip/tooltip.directive';

@Component({
    standalone: true,
    imports: [NgTemplateOutlet, RouterLink, RouterLinkActive, TooltipDirective],
    // eslint-disable-next-line @angular-eslint/component-selector
    selector: 'nav-item',
    templateUrl: './nav-item.component.html',
    styleUrls: ['./nav-item.component.scss'],
    animations: [
        trigger('slideDownUp', [
            state('collapsed', style({height: '0px', overflow: 'hidden', opacity: 0})),
            state('expanded', style({height: '*', overflow: 'visible', opacity: 1})),
            transition('collapsed <=> expanded', [animate('300ms ease-in-out')])
        ])
    ]
})
export class NavItemComponent {
    text = input.required<string | TemplateRef<unknown>>();

    navItemClick = output<void>();
    routerLink = input<string[]>();
    customClass = input<string>('');

    iconClass = input<string>('');
    imageSrc = input<string>();
    imageStyle = input<string>('');

    ariaLabel = input<string>();
    ariaExpanded = input<boolean>();

    hasSubmenu = input<boolean>(false);
    submenuExpanded = input<boolean>(false);
    routerLinkActiveOptions = input<{exact: boolean} | IsActiveMatchOptions>();
    tooltipHtml = input<string>('');

    readonly textTemplate = computed<TemplateRef<unknown> | null>(() => {
        const t = this.text();
        return t instanceof TemplateRef ? t : null;
    });

    readonly textString = computed<string | null>(() => {
        const t = this.text();
        return t instanceof TemplateRef ? null : t;
    });

    iconClassWithMargin = computed(() => `${this.iconClass()} me-3`);
    imageAlt = computed(() => `${this.textString() ?? this.ariaLabel() ?? 'Navigation'} icon`);
}
